// extracted by mini-css-extract-plugin
export default {"root":"ex8KaOYbrNDix19sbOwY","placeHolderShimmer":"MA__nvhi9q5YVOsjFTuQ"};